// Wärtsilä Online translations exported from Salesforce. Please see "Translations" in Confluence for correct workflow.
import { ITranslations } from "../../localization";

// tslint:disable-next-line: variable-name
export const contracts_en_US: ITranslations = {
  en_US: {
    "contracts.appliesTo": "Applies to",
    "contracts.attachmentDocumentTypes": "Documents ({types})",
    "contracts.attachmentImageTypes": "Images ({types})",
    "contracts.attachmentsMessage": "You can upload the following types of attachments with a maximum file size of {maxSize}.",
    "contracts.cbmExpertName": "Asset diagnostics",
    "contracts.contact": "Contact",
    "contracts.contactInformation": "Contact information",
    "contracts.contactPerson": "Contact person",
    "contracts.contractManager": "Contract manager",
    "contracts.contractNumber": "Agreement number",
    "contracts.contractType": "Type",
    "contracts.emailSupport": "Email support",
    "contracts.expertiseCenter": "Expertise center",
    "contracts.expiry": "Expiry date",
    "contracts.installationAndProductContracts": "Installation and product agreements",
    "contracts.installationAndProductContracts:energy": "Power plant and product agreements",
    "contracts.installationAndProductContracts:marine": "Vessel and product agreements",
    "contracts.invalidContract": "Invalid agreement",
    "contracts.maintenancePlannerName": "Maintenance planning",
    "contracts.noContactPerson": "No contact person",
    "contracts.noContractsAvailable": "No agreements available",
    "contracts.phoneNumber": "Phone number",
    "contracts.phonePINNumber": "Phone PIN number",
    "contracts.remoteOperationalSupportContactInformation": "Remote Operational Support Contact Information",
    "contracts.remoteSupporterName": "Remote supporter",
    "contracts.service": "Service",
    "contracts.showAll": "Show all",
    "contracts.showLess": "Show less",
    "contracts.startDate": "Start date",
    "contracts.unplannedRequests.eventsAndSpareParts": "Events & spare parts",
    "contracts.unplannedRequests.event": "Event",
    "contracts.unplannedRequests.removeEvent": "Remove event",
    "contracts.unplannedRequests.removeEventTitle": "Remove event",
    "contracts.unplannedRequests.removeEventConfirm": "Are you sure you want to remove this event?",
    "contracts.unplannedRequests.addNewEvent": "Add a new event",
    "contracts.unplannedRequests.product": "Product",
    "contracts.unplannedRequests.date": "Event date",
    "contracts.unplannedRequests.eventDateRequired": "Event date is required",
    "contracts.unplannedRequests.productRequired": "Product is required",
    "contracts.unplannedRequests.engineRunningHoursRequired": "Engine running hours is required",
    "contracts.unplannedRequests.engineRunningHoursInvalid": "Engine running hours must be a number between 0 and 9 999 999 999!",
    "contracts.unplannedRequests.failureTypeRequired": "Failure type is required",
    "contracts.unplannedRequests.failureSystemRequired": "Failure system is required",
    "contracts.unplannedRequests.failureComponentRequired": "Failure component is required",
    "contracts.unplannedRequests.affectedCylinderRequired": "Affected cylinder is required",
    "contracts.unplannedRequests.descriptionRequired": "Description is required",
    "contracts.unplannedRequests.downtimeInvalid": "Downtime must be a number between 0 and 9 999 999 999!",
    "contracts.unplannedRequests.engineRunningHours": "Engine running hours",
    "contracts.unplannedRequests.componentRunningHours": "Component running hours",
    "contracts.unplannedRequests.componentSerialNumber": "Component serial number",
    "contracts.unplannedRequests.failurePart": "Failure part",
    "contracts.unplannedRequests.partsInStockOnboard": "Parts in stock onboard",
    "contracts.unplannedRequests.requiredForRestart": "Required to restart the equipment",
    "contracts.unplannedRequests.downtime": "Downtime",
    "contracts.unplannedRequests.failureType": "Failure type",
    "contracts.unplannedRequests.failureSystem": "Failure system",
    "contracts.unplannedRequests.failureComponent": "Failure component",
    "contracts.unplannedRequests.descriptionAndActionsTaken": "Description of the failure and actions already taken",
    "contracts.unplannedRequests.affectedCylinder": "Affected cylinder",
    "contracts.unplannedRequests.spareParts": "Spare parts",
    "contracts.unplannedRequests.generalInformation": "General information",
    "contracts.unplannedRequests.newSparePartReplenishmentRequest": "New spare part replenishment request",
    "contracts.unplannedRequests.noRequestsFound": "No unplanned event requests found",
    "contracts.unplannedRequests.poNumber": "PO number",
    "contracts.unplannedRequests.savePONumber": "Save PO number",
    "contracts.unplannedRequests.savePONumberSuccess": "PO number saved successfully",
    "contracts.unplannedRequests.informationNeededNotice": "This request requires additional information.",
    "contracts.unplannedRequests.approvalStatus": "Approval status",
    "contracts.unplannedRequests.reason": "Reason",
    "contracts.unplannedRequests.exportAllParts": "Export all parts",
    "contracts.unplannedRequests.exportApprovedParts": "Export approved parts",
    "contracts.unplannedRequests.waitingForPONotice": "This request is awaiting tracking PO to proceed.",
    "contracts.unplannedRequests.itemRequiresInformationNotice": "This item requires additional information.",
    "contracts.unplannedRequests.requestNumber": "Request number",
    "contracts.unplannedRequests.requestStatus": "Request status",
    "contracts.unplannedRequests.requestType": "Request type",
    "contracts.unplannedRequests.requestTypeRequired": "Request type is required",
    "contracts.unplannedRequests.salesOrder": "Sales order",
    "contracts.unplannedRequests.sparePartReplenishment": "Spare part replenishment",
    "contracts.unplannedRequests.submittedDate": "Submitted date",
    "contracts.unplannedRequests.summary": "Summary",
    "contracts.unplannedRequests.title": "Unplanned event requests",
    "contracts.unplannedRequests.sending": "Sending unplanned request",
    "contracts.unplannedRequests.sendingSuccess": "Unplanned request sent successfully",
    "contracts.unplannedRequests.selectedSpareParts": "Selected spare parts",
    "contracts.unplannedRequests.savingDraft": "Saving draft",
    "contracts.unplannedRequests.savingDraftSuccess": "Draft was saved successfully",
    "contracts.unplannedRequests.savingDraftFailed": "Saving draft failed",
    "contracts.unplannedRequests.sendingFailed": "Sending unplanned request failed",
    "contracts.unplannedRequests.resubmit": "Save and send",
    "contracts.unplannedRequests.resubmitting": "Sending",
    "contracts.unplannedRequests.resubmitSuccess": "Request sent for review",
    "contracts.unplannedRequests.resubmitFailed": "Sending failed",
    "contracts.unplannedRequests.raiseConcern": "Raise a concern for selected parts",
    "contracts.unplannedRequests.selectForConcern": "Select to raise concern",
    "contracts.unplannedRequests.raisingConcern": "Raising concern",
    "contracts.unplannedRequests.raiseConcernSuccess": "Concern raised successfully",
    "contracts.unplannedRequests.raiseConcernFailed": "Raising concern failed",
    "contracts.unplannedRequests.viewPartInEventsPhase": "Concern raised, view part",
    "contracts.tac.assignees": "Assignees",
    "contracts.tac.customerComment": "Please provide a summary of the performed or planned actions and the schedule if still pending",
    "contracts.tac.customerCommentReadOnly": "Summary of the performed or planned actions and the schedule if still pending",
    "contracts.tac.done": "Done",
    "contracts.tac.noCasesFound": "No cases found",
    "contracts.tac.planned": "Planned",
    "contracts.tac.priority": "Priority",
    "contracts.tac.reopenDescription": "Reopen description",
    "contracts.tac.saveChanges": "Save changes",
    "contracts.tac.serviceWorkReport": "Service work report",
    "contracts.tac.showOnlyOverdue": "Show only overdue cases",
    "contracts.tac.technicalAuditCases": "Technical Audit Cases",
    "contracts.tac.validation.summaryIsRequired": "Summary is required",
    "contracts.tac.wartsilaContact": "Wärtsilä contact",
    "contracts.technicalExperts": "Technical experts",
    "contracts.validation.messageIsRequired": "Message is required",
    "contracts.validation.subjectIsRequired": "Subject is required",
  },
};
